import { moveToFulfilled, update } from '@ms/yammer-data-support';
import type { Reducer } from 'redux';

import type { GroupAddUserFulfilledAction } from '../../domains/groupAddRemoveUser/actions.types';
import type { M365CopilotSuggestedMemberCountLoadFulfilledAction } from '../../domains/m365CopilotGroupSuggestedMemberCounts/actions.types';
import type { M365CopilotSuggestedMembersAddAllFulfilledAction } from '../../domains/m365CopilotGroupSuggestedMembers/actions.types';

import type { M365CopilotGroupSuggestedMemberCounts } from './types';

export type M365CopilotGroupSuggestedMemberCountsAction =
  | M365CopilotSuggestedMemberCountLoadFulfilledAction
  | GroupAddUserFulfilledAction
  | M365CopilotSuggestedMembersAddAllFulfilledAction;

export const initialState: M365CopilotGroupSuggestedMemberCounts = {
  pending: { byId: {} },
  fulfilled: { byId: {} },
  rejected: { byId: {} },
};

type UpdateGroupSuggestedMemberCount = (
  state: M365CopilotGroupSuggestedMemberCounts,
  groupId: string,
  delta: number
) => M365CopilotGroupSuggestedMemberCounts;
const updateGroupSuggestedMemberCount: UpdateGroupSuggestedMemberCount = (state, groupId, delta) => {
  const currentCount = state.fulfilled.byId[groupId]?.totalCount ?? 0;

  if (currentCount === 0) {
    return state;
  }

  return update(state, groupId, { totalCount: currentCount + delta });
};

const reducer: Reducer<M365CopilotGroupSuggestedMemberCounts, M365CopilotGroupSuggestedMemberCountsAction> = (
  state = initialState,
  action
) => {
  switch (action.type) {
    case 'M365_COPILOT_SUGGESTED_MEMBER_COUNT.LOAD_FULFILLED':
      return moveToFulfilled(state, action.payload.entities.m365CopilotGroupSuggestedMemberCounts);
    case 'GROUP.ADD_USER_FULFILLED':
      return updateGroupSuggestedMemberCount(state, action.payload.groupId, -1);
    case 'M365_COPILOT_SUGGESTED_MEMBERS.ADD_ALL_FULFILLED':
      return update(state, action.payload.id, { totalCount: 0 });
    default:
      return state;
  }
};

export default reducer;
